import { AccountTypeEnum } from "./AccountTypeEnum";

const accountTypeOptions = [
  AccountTypeEnum.SimpleIRA,
  AccountTypeEnum.SEPIRA,
  AccountTypeEnum.SARSEPIRA,
  AccountTypeEnum.TraditionalIRA,
  AccountTypeEnum.RolloverIRA,
  AccountTypeEnum.QualifiedRetirementPlan,
  AccountTypeEnum.Plan403b,
  AccountTypeEnum.Governmental457bPlan,
  AccountTypeEnum.RothIRA
];

export default accountTypeOptions;
